import axios from 'axios'

import {HOST} from '../../config'

export const ActionConst = {
  SET_DATA_OBJECT: 'CAD_ACESSO_SET_DATA_OBJECT',
  IS_FETCHING: 'CAD_ACESSO_IS_FETCHING',
  IS_OPEN: 'CAD_ACESSO_IS_OPEN',
  SET_ERROR: 'CAD_ACESSO_SET_ERROR'
}

function _setDataObject (dataObject) {
  return {
    type: ActionConst.SET_DATA_OBJECT,
    dataObject
  }
}

function _isOpen (isOpen) {
  return {
    type: ActionConst.IS_OPEN,
    isOpen
  }
}

function _isFetching (isFetching) {
  return {
    type: ActionConst.IS_FETCHING,
    isFetching
  }
}

function _setError (error) {
  return {
    type: ActionConst.SET_ERROR,
    error
  }
}

export function setPropDataObject (data) {
  return (dispatch, getState) => {
    let {dataObject} = getState().cadAcesso
    dispatch(_setDataObject({...dataObject, ...data}))
  }
}

export function load (acesso) {
  return (dispatch) => {
    if (acesso) {
      //Editar acesso
      dispatch(_setDataObject(acesso))
    } else {
      //Novo acesso
      dispatch(_setDataObject({used_licenses: 0}))
    }

    dispatch(_isOpen(true))
  }
}

export function close () {
  return (dispatch) => {
    dispatch(_isOpen(false))
  }
}

function _salvarPost (dataObject) {
  return (dispatch) => {
    let url = `${HOST}/api/mobile/accounts`

    return axios.post(url, dataObject).then(response => {
      let id = response.data.__id__
      return {id, acesso: dataObject}
    }).catch((error) => {
      if (error.response) {
        error = error.response.data.error
      }
      return Promise.reject(error)
    })
  }
}

function _salvarPut (dataObject) {
  return (dispatch) => {
    let url = `${HOST}/api/mobile/accounts/${dataObject.id}`

    return axios.put(url, dataObject).then(response => {
      return {acesso: dataObject}
    }).catch((error) => {
      if (error.response) {
        error = error.response.data.error
      }
      return Promise.reject(error)
    })
  }
}

function _isError ({value, propToValidate, minLength, iSelectErr}) {
  minLength = minLength || 1

  let type = typeof value
  switch (type) {
    case 'undefined':
      return true
    case 'string':
      return (value.length < minLength)
    case 'object':
      if (value == null) {
        return true
      } else if (value instanceof Array) {
        return (value.length < minLength)
      }
      return false
    default:
      return false
  }
}

function _validaForm ({dispatch, required, dataObject}) {
  return new Promise((resolve, reject) => {
    if (required) {
      let error = {length: 0}
      for (let prop in required) {
        if (required[prop]) {
          let value = dataObject[prop]
          if (_isError({value})) {
            error[prop] = true
            error.length++
          }
        }
      }
      //dispatch(_setError(error))
      if (error.length > 0) {
        error = {...error, response_code:'Error', message: 'Um ou mais campos obrigatórios não foram informados!'}
        reject(error)
      }
    }
    resolve()
  })
}

function _salvar () {
  return (dispatch, getState) => {
    let {dataObject, required} = getState().cadAcesso

    return _validaForm({dispatch, required, dataObject}).then(() => {
      if (dataObject.id) {
        //Editar
        return dispatch(_salvarPut(dataObject))
      }
      //Novo
      return dispatch(_salvarPost(dataObject))
    })
  }
}

export function salvar () {
  return (dispatch) => {
    dispatch(_isFetching(true))

    return dispatch(_salvar()).then((data) => {
      dispatch(_isOpen(false))
      dispatch(_isFetching(false))
      return data
    }).catch((error)=>{
      dispatch(_setError(error))
      dispatch(_isFetching(false))
      return Promise.reject(error)
    })
  }
}


// WEBPACK FOOTER //
// ./src/actions/acesso/CadAcesso.js